<template>
     <v-layout v-if="configOK" align-start row wrap justify-center class="mt-0">
            
            <v-flex flex xs12 sm12 md12 lg12 class="mt-0" v-if="itemsF.length > 0">
                <v-data-table :items="itemsF" hide-actions  hide-headers style="width: 100%;" class=" red mt-0">
                    <template slot="items" slot-scope="props">
                        <tr style="height:2px">

                        </tr>
                        <tr v-if="props.index === 0">
                            <td class="black darken-4"  colspan="2">  <img class="menuLogo ml-0 mt-2" src="../assets/images/Logo.png" style="height: 25px" /></td>
                            <td  @click="setCurrentItem(props.item) "
                                :class=" 'black white--text text-xs-center no-wrap '">
                                <strong>{{getUltimoPassaggio(props.item)  }} </strong>
                            </td>
                        </tr>
                      
                        <tr v-if="getUltimoPassaggio(props.item) !== undefined">
                            <td v-if="props.index %2 === 0" @click="setCurrentItem(props.item) " width="1%"
                                :class=" ' blue darken-4 white--text text-xs-left no-wrap '">
                                <strong style="margin-left:2px">
                                    {{ props.item.posAss }} 
                                </strong>
                            </td>
                            <td v-if="props.index %2 !== 0" @click="setCurrentItem(props.item) " width="1%"
                                :class=" ' blue darken-2 white--text text-xs-left no-wrap '">
                                <strong style="margin-left:2px" >
                                    {{ props.item.posAss }} 
                                </strong>
                            </td>
                         
                            <td v-if="props.index %2 === 0" @click="setCurrentItem(props.item) "
                                :class=" ' blue darken-4 white--text text-xs-left no-wrap '">
                                <strong style="margin-left:2px" v-if="showAtleta">
                                    {{ props.item.cognome }} {{ props.item.nome.substring(0,1)+"." }}
                                </strong>
                            </td>
                            <td v-if="props.index %2 !== 0" @click="setCurrentItem(props.item) "
                                :class=" ' blue darken-2 white--text text-xs-left no-wrap '">
                                <strong style="margin-left:2px" v-if="showAtleta">
                                    {{ props.item.cognome }} {{ props.item.nome.substring(0,1)+"." }}
                                </strong>
                            </td>
                            <!--td @click="setCurrentItem(props.item)" v-if="showTempo"
                                :class="getColor('colorTempo') + ' text-xs-center nowrap'">
                                <strong>{{ getUltimoTempo(props.item) }}</strong>
                            </td -->
                            <td nowrap v-if="showGap && props.index == 0 && getUltimoPassaggio(props.item) !== 'ARRIVO'"
                                :class=" 'red darken-4 white--text text-xs-center nowrap font-weight-black'">
                                Leader 
                            </td>
                            <td nowrap v-if="showGap && props.index == 0 && getUltimoPassaggio(props.item) === 'ARRIVO'"
                                :class=" 'white black--text text-xs-center nowrap font-weight-black'">
                                {{ getUltimoTempo(props.item) }}
                            </td>
                            <td nowrap v-if="showGap && props.index > 0"
                                :class=" 'black yellow--text text-xs-center nowrap '">
                                {{ (props.item.distacco1) }}
                            </td>
                            
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
          
         

        </v-layout>
</template>
    
<script>
import helper from '../helper';
import dayjs from 'dayjs';

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],
            itemsF2: [],

            showButtons: true,

            compatta: true,
            categoriaSelected: 'TUTTE',
            sessoSelected: 'TUTTI',
            divisioneSelected: 'TUTTE',
            nazioneSelected: 'TUTTE',

            listaCategorie: [],
            listaSesso: ['TUTTI', 'MASCHILE', 'FEMMINILE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            raceTitle: '',

            connection: null,

            configEvento: {},
            elencoIscritti: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            chipMap: {},
            mappaIntermedi: {},

            currentIndex: 1,
            listaIntermedi: [],

            stats: false,
            loaded: false,
            dettaglio: false,
            dettaglioBands: false,
            currentItem: null,
            currentRilevamenti: {},

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            multiDivisione: false,
            mappaDivisioni: {},
            listaDivisioni: [],

            mappaFiles: {},
            clockBatterie: {},
            clockBatterieFinish: {},

            local: undefined,
            showDivisione: false,
            showBatteria: false,
            showGap: false,
            showMedia: false,
            showPrint: false,
            showDownload: false,


            color: 'red',
            baseColor: 'white:black',
            numFrac: 1,
            refreshData: 60000,
            refreshPage: 300000,
            showTimer: true,
            showProgressBar: true,
            showHeaders: true,

            numRilevamentiStep: 0,

            filtroDialog: false,

            warningDelta: 2,
            warningLaps: 5,
            onlyWarning: false,

            filtraPosCat: 0,

            orderByField: null,
            direction: true,

            raceTime: '00:00:00',

            addClockDialog: false,
            clockToAdd: "",
            rilevamentoSelected: undefined,
            rilevamentoSelectedTitle: undefined,
            rilevamentoSelectedType: undefined,

            configOK: false,
            mostraNazione: false,
            listaNazioni: [],

            logo: "logo_icron_2.0_bianco"



        };
    },

    beforeCreate() { 

    },

    created() { 

        

    },

    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;


        this.isLocale = true;
        if (window.location.hostname.indexOf("icron.it") != -1) {
            this.isLocale = false;
        }

        


        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);

        this.loadEvento();
    },

    methods: {

        loadEvento() {
            this.listaIntermedi = [];
            this.elencoIscritti = [];

            console.log(this.raceID);
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    this.configRace(response);
                } else {
                    //alert("Evento non configurato.");
                    this.configEvento = {}

                    if (this.local !== undefined) {
                        const toks = this.local.split(",");
                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                            }
                        })
                    }
                }

            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

          /*  if (this.configEvento.liveTemplate !== undefined) {
                let _url = "/" + this.configEvento.liveTemplate + "/" + this.raceID + "/" + this.paramID;
                if (this.local !== undefined) _url += "/" + this.local;
                this.$router.push(_url);
                return;
            }*/


            if (this.configEvento.gunTime.indexOf(".") == -1) this.configEvento.gunTime += ".000";

            for (let i = 1; i < 100; i++) {
                //alert(this.configEvento['split' + i]) ;
                if (this.configEvento['split' + i] !== undefined) {
                    this.configEvento.numSplit = i;
                } else {
                    break;
                }
            }

            //alert(this.configEvento.numSplit);

            //this.configEvento.numSplit = parseInt(this.configEvento.numSplit);
            if (this.configEvento.timeFormat == undefined) this.configEvento.timeFormat = 'HH:mm:ss.SSS';
            if (this.configEvento.gapFormat == undefined) this.configEvento.gapFormat = 'HH:mm:ss';

            this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
            this.baseColor = this.configEvento.baseColor !== undefined ? this.configEvento.baseColor : this.baseColor;
            this.showGap = (this.configEvento.showGap !== undefined && this.configEvento.showGap == 'true') ? true : false;
            this.showMedia = (this.configEvento.showMedia !== undefined && this.configEvento.showMedia == 'true') ? true : false;
            this.numFrac = (this.configEvento.numFrac !== undefined) ? parseInt(this.configEvento.numFrac) : 0;

            this.showDivisione = (this.configEvento.showDivisione !== undefined && this.configEvento.showDivisione == 'true') ? true : false;
            this.showPosAssoluta = (this.configEvento.showPosAssoluta !== undefined && this.configEvento.showPosAssoluta == 'true') ? true : false;
            this.showPosDivisione = (this.configEvento.showPosDivisione !== undefined && this.configEvento.showPosDivisione == 'true') ? true : false;
            this.showPosMF = (this.configEvento.showPosMF !== undefined && this.configEvento.showPosMF == 'true') ? true : false;
            this.showSesso = (this.configEvento.showSesso !== undefined && this.configEvento.showSesso == 'true') ? true : false;
            this.showPettorale = (this.configEvento.showPettorale !== undefined && this.configEvento.showPettorale == 'true') ? true : false;
            this.showNazione = (this.configEvento.showNazione !== undefined && this.configEvento.showNazione == 'true') ? true : false;
            this.showAtleta = (this.configEvento.showAtleta !== undefined && this.configEvento.showAtleta == 'true') ? true : false;
            this.showCategoria = (this.configEvento.showCategoria !== undefined && this.configEvento.showCategoria == 'true') ? true : false;
            this.showPosCategoria = (this.configEvento.showPosCategoria !== undefined && this.configEvento.showPosCategoria == 'true') ? true : false;
            this.showSquadra = (this.configEvento.showSquadra !== undefined && this.configEvento.showSquadra == 'true') ? true : false;
            this.showGiri = (this.configEvento.showGiri !== undefined && this.configEvento.showGiri == 'true') ? true : false;
            this.showOrario = (this.configEvento.showOrario !== undefined && this.configEvento.showOrario == 'true') ? true : false;
            this.showTempo = (this.configEvento.showTempo !== undefined && this.configEvento.showTempo == 'true') ? true : false;
            this.showMetri = (this.configEvento.showMetri !== undefined && this.configEvento.showMetri == 'true') ? true : false;
            this.showBatteria = (this.configEvento.showBatteria !== undefined && this.configEvento.showBatteria == 'true') ? true : false;


            this.showButtons = (this.configEvento.showButtons !== undefined && this.configEvento.showButtons == 'false') ? false : true;
            this.showPrint = (this.configEvento.showPrint !== undefined && this.configEvento.showPrint == 'true') ? true : false;
            this.showDownload = (this.configEvento.showDownload !== undefined && this.configEvento.showDownload == 'true') ? true : false;

            this.showTimer = (this.configEvento.showTimer !== undefined && this.configEvento.showTimer == 'true') ? true : false;
            this.showProgressBar = (this.configEvento.showProgressBar !== undefined && this.configEvento.showProgressBar == 'false') ? false : true;
            this.showHeaders = (this.configEvento.showHeaders !== undefined && this.configEvento.showHeaders == 'false') ? false : true;


            this.refreshPage = (this.configEvento.refreshPage !== undefined) ? parseInt(this.configEvento.refreshPage) * 1000 : 300000;
            this.refreshData = (this.configEvento.refreshData !== undefined) ? parseInt(this.configEvento.refreshData) * 1000 : 60000;

            if (this.local == undefined && !this.isLocale) {
                this.refreshData = 60000;
                console.log("SONO SU INTERNET! Forzo refresh a 60 secondi ")
            }

            this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
            this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false
            this.filtraPosCat = (this.configEvento.filtraPosCat !== undefined) ? parseInt(this.configEvento.filtraPosCat) : 0

            this.indexTo = (this.configEvento.indexTo !== undefined) ? parseInt(this.configEvento.indexTo) : -1

            this.warningDelta = (this.configEvento.warningDelta !== undefined) ? parseFloat(this.configEvento.warningDelta) : 2
            this.warningLaps = (this.configEvento.warningLaps !== undefined) ? parseFloat(this.configEvento.warningLaps) : 5

            this.logo = (this.configEvento.logo !== undefined) ? this.configEvento.logo: this.logo

            if (this.configEvento.metriPerGiro !== undefined) this.configEvento.metriPerGiro = this.configEvento.metriPerGiro.replace(",", ".");

            if (this.isOCR()) this.configEvento.criterioClass = "col_bands,tempo"

            this.fields = [];
            if (this.configEvento.fields !== undefined) {
                this.fields = this.configEvento.fields.split(",");
            }

            if (this.configEvento.batterie !== undefined) {
                let batterie = this.configEvento.batterie.split(",");
                batterie.forEach(batt => {
                    console.log("Batteria " + batt + " : " + this.configEvento['batteria' + batt])
                    let _batt = this.configEvento['batteria' + batt];
                    if (_batt !== undefined) {
                        let _battTok = _batt.split("-");
                        this.clockBatterie[batt] = _battTok[0];
                        this.clockBatterieFinish[batt] = _battTok[1];

                    }
                })
            } else {
                console.log("Nessuna batteria")
            }

            this.raceTitle = this.configEvento['raceTitle'];
            for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                this.listaIntermedi.push(index);
                this.mappaIntermedi[index] = 0;

                const split = this.configEvento['split' + index];
                if (split !== undefined) {
                    const toks = split.split(",");
                    //split3=CONTADINA KM38,tagFileRef=file2,valTime=180,numLap=1
                    this.configEvento['titolo' + index] = toks[0];

                    toks.forEach(tok => {
                        if (tok.indexOf("=") !== -1) {
                            const keyval = tok.split("=");
                            this.configEvento[keyval[0] + index] = this.normalize(keyval[1]);
                        }
                    })
                }
                console.log(this.configEvento);

            }


            let res = (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)

            console.log(">>>>>>>>>>>>>  IS OCR:" + res)

            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            //if (this.local) _url = "/local/"+ this.raceID+ "/localLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            this.getRemoteService(_url).then((response) => {
                this.elencoIscritti = this.csvJSON(response).filter(elem => {
                    let res = true;
                    if (this.configEvento.filtroCategorie) {
                        const found = this.configEvento.filtroCategorie.split(",").find(element => element === elem.categoria);
                        res = found !== undefined;
                    }
                    if (res) {
                        if (this.configEvento.filtroDivisioni) {
                            console.log("FILTRO DIVISIONI ATTIVO:" + this.configEvento.filtroDivisioni)
                            const found = this.configEvento.filtroDivisioni.split(",").find(element => element === elem.divisione);
                            res = found !== undefined;
                        }
                    }

                    if (res) {
                        if (this.configEvento.filtroSottoclassifica) {
                            console.log(" filtroSottoclassifica ATTIVO:" + this.configEvento.filtroSottoclassifica)
                            const found = this.configEvento.filtroSottoclassifica.split(",").find(element => element === elem.classif);
                            res = found !== undefined;
                        }
                    }

                    if (res) {
                        if (this.configEvento.filtroSesso) {
                            console.log(" filtroSesso ATTIVO:" + this.configEvento.filtroSesso)
                            res = this.configEvento.filtroSesso === elem.sesso;
                        }
                    }

                    if (this.configEvento.filtroPettorale !== undefined) {
                        const listaPett = this.configEvento.filtroPettorale.split(",");
                        const found = listaPett.find(element => element === elem.pett);
                        res = found !== undefined;
                    }

                    return res
                });

                this.mappaDivisioni = {};
                this.mappaMetriDivisioni = {};
                this.listaDivisioni = [];
                this.listaCategorie = [];
                let mappaCategorie = {};
                let mappaNazioni = {};

                this.listaDivisioni.push('TUTTE');
                this.listaCategorie.push("TUTTE");


                this.elencoIscritti.forEach(elem => {
                    if (elem.nazione && elem.nazione.length > 3) {
                        elem.nazione = elem.nazione.substring(0, 3).toLowerCase();
                    } else if (elem.nazione === undefined || elem.nazione === '') {
                        elem.nazione = 'ita';
                    }
                    elem.nazione = this.normalizeNaz(elem.nazione);
                    mappaNazioni[elem['nazione']] = elem['nazione'];


                    if (elem['partenza onda'] != undefined) {
                        elem.batteria = elem['partenza onda']
                    }

                    if (this.isOCR() && elem.col_bands == undefined) {
                        elem.col_bands = 0;
                    }

                    if (elem.pettorale !== undefined) {
                        elem.pett = elem.pettorale
                    } else if (elem.p !== undefined) {
                        elem.pett = elem.p
                    } else if (elem.dorsale !== undefined) {
                        elem.pett = elem.dorsale
                    } else if (elem.dors !== undefined) {
                        elem.pett = elem.dors
                    }

                    elem.rilevamenti = {};
                    for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                        elem.rilevamenti[index] = [];
                    }

                    if (elem['chip'] != undefined) {
                        if (elem['chip'].indexOf("-") !== -1) {
                            let chips = elem['chip'].split("-");
                            chips.forEach(chip => {
                                this.chipMap[chip] = elem;
                            })
                        } else {
                            this.chipMap[elem['chip']] = elem;
                        }
                    }

                    this.chipMap[elem['pett']] = elem; // aggiungo anche la possibilità di usare il pettorale come chip

                    if (elem.guntime == undefined || elem.guntime == '') {
                        elem.guntime = this.configEvento.gunTime;

                        if (this.configEvento['gunTime' + elem.divisione] !== undefined && this.configEvento['gunTime' + elem.divisione] !== '') {
                            elem.guntime = this.configEvento['gunTime' + elem.divisione];
                        }

                        if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterie[elem.batteria] !== undefined) {
                            elem.guntime = this.clockBatterie[elem.batteria];
                        }
                        if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterieFinish[elem.batteria] !== undefined) {
                            elem.finishtime = this.clockBatterieFinish[elem.batteria];
                        }
                    }

                    elem.distanzaDivisione = this.configEvento.distanza;
                    if (this.configEvento['distanza' + elem.divisione] !== undefined && this.configEvento['distanza' + elem.divisione] !== '') {
                        elem.distanzaDivisione = this.configEvento['distanza' + elem.divisione];
                    }


                    let mdiv = this.mappaDivisioni[elem['divisione']];
                    if (mdiv === undefined && elem['divisione'] != undefined) {
                        let numLaps = -1;
                        if (this.configEvento['giriDivisione' + elem['divisione']]) {
                            numLaps = parseInt(this.configEvento['giriDivisione' + elem['divisione']]);
                        }

                        let metriLaps = 0;
                        let md = this.configEvento['metriDivisione' + elem['divisione']];
                        if (md !== undefined) {
                            md = md.replace(",", ".");
                            metriLaps = parseFloat(md).toFixed(2);
                            console.log("METRILAPS:" + metriLaps)
                        }

                        this.mappaDivisioni[elem['divisione']] = {
                            id: elem['divisione'],
                            numGiri: numLaps,
                            deltaMetri: metriLaps
                        };
                        //this.listaDivisioni.push(elem['divisione']);
                        console.log("Divisione aggiunta: >>" + JSON.stringify(this.mappaDivisioni[elem['divisione']]) + "<<")
                    }
                    const _cc = elem['sesso'] + " - " + elem['categoria'];
                    mappaCategorie[_cc] = elem['categoria'];
                    console.log("Categoria aggiunta: >>" + mappaCategorie[_cc] + "<<")
                })

                //if (this.configEvento.filtroDivisioni === undefined) {
                this.listaDivisioni = Object.keys(this.mappaDivisioni);
                if (this.listaDivisioni.length > 1) {
                    this.multiDivisione = true;
                    this.listaDivisioni.unshift("TUTTE");
                }
                //  }
                this.listaDivisioni.sort();

                this.listaCategorie = Object.keys(mappaCategorie);
                if (this.listaCategorie.length > 1) {
                }
                //  }
                this.listaCategorie.sort();

                this.mostraNazione = Object.keys(mappaNazioni).length > 1;
                this.listaNazioni = Object.keys(mappaNazioni);
                this.listaNazioni.sort();
                this.listaNazioni.unshift("TUTTE");


                this.refresh(this);
                this.myInterval = setInterval(this.refresh, this.refreshData, this);
                this.myIntervalBar = setInterval(this.refreshBar, 1000, this);
                setTimeout(this.refreshAll, this.refreshPage);
            });
        },

        isAdmin() {
            if (this.configEvento.admin !== undefined && this.configEvento.admin == 'admin123') return true;
            return this.configEvento.admin !== undefined && this.configEvento.admin === ((this.raceID + this.paramID).split("").reverse().join(""));
        },

        isRealTime() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('realtime') !== -1)
        },

        isMultilap() {
            return this.isUltra() || (this.configEvento.raceType !== undefined && this.configEvento.raceType == 'multilap')
            //return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('multilap') !== -1)
        },

        isOCR() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)
        },

        isMultiDay() {
            return (this.configEvento.multiDay !== undefined && this.configEvento.multiDay == 'true')
        },


        isUltra() {
            return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ultra') !== -1)
        },

        isMultiDivisione() {
            return this.listaDivisioni.length > 1;
        },

        refreshAll() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            //alert("Riavvio pagina")
            window.location.reload();

        },

        getFieldValue(item, field) {
            if (field.fieldType == 'field') {
                console.log(field.columnName)
                return item[field.columnName]
            }
            if (field.fieldType == 'distanza') {
                let delta = 0;
                //console.log("ECCOMI");
                if (this.mappaDivisioni[item.divisione] && this.mappaDivisioni[item.divisione].deltaMetri) {
                    delta = parseFloat(this.mappaDivisioni[item.divisione].deltaMetri)
                }

                if (item.distanza !== undefined && !isNaN(item.distanza)) {
                    delta += parseFloat(item.distanza)
                }


                const numLaps = item.rilevamenti[1].length;
                const mpg = parseFloat(this.configEvento.metriPerGiro);
                const value = parseFloat((numLaps * mpg) + delta).toFixed(2);
                //console.log(value);
                return value
            }

            return item[field.fieldType + field.splitNum]
        },

        getColumnName(field) {
            return field.columnName
        },

        getFieldName(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[0];
            }
            return key;
        },

        getFieldlabel(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[1];
            }
            return key;
        },

        getColor(columnName, valore) {
            let colore = this.configEvento[columnName + valore];
            if (colore === undefined) {
                colore = this.configEvento[columnName];
                if (colore === undefined) {
                    colore = this.configEvento.baseColor;
                }
            }
            if (colore !== undefined) {
                if (colore.indexOf(":") !== -1) {
                    return colore.split(":")[0] + ' ' + colore.split(":")[1] + '--text '
                } else {
                    return colore + ' white--text '
                }
            }
            return 'white black--text '
        },

        getUltimoPassaggio(item, tailNum = 1) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti && item.rilevamenti[1]) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        return (numLaps - tailNum + 1);
                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        return this.configEvento['titolo' + index];
                    }
                }
            }
            /*    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (this.isMultilap()) {
                        if (item && item.rilevamenti) {
                            let numLaps = item.rilevamenti[index].length;
                            if (tailNum <= numLaps) {
                                return this.configEvento['titolo' + index] + " " + (numLaps - tailNum + 1);
                            }
                        }
                    }
 
                }*/
            return undefined;
        },
        getUltimoTempo(item, tailNum = 1, riduci = true) {

            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][numLaps - tailNum]['time']);
                        else
                            return (item.rilevamenti[1][numLaps - tailNum]['time']);

                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        let t = item['tempo' + index];
                        //console.log(">>>" + this.configEvento.timeFormat)

                        if (this.configEvento.timeFormat === 'HH:mm:ss'){
                            //console.log("aa")
                            return t.substring(0,8);
                        } else {
                            return t;
                        }
                    }
                }
            }

            return undefined;
        },

        getUltimoOrario(item, tailNum = 1) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        return this.riduci(item.rilevamenti[1][numLaps - tailNum]['clock']);
                    }
                }
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    if (item['tempo' + index] !== undefined) {
                        return this.riduci(item.rilevamenti[index][numLaps - tailNum]['clock']);
                    }
                }
            }
            return undefined;
        },

        getFrazione(item, indexRil = 0, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (indexRil < numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][indexRil]['fraz']);
                        else
                            return (item.rilevamenti[1][indexRil]['fraz']);
                    }
                }
            }
            return undefined;
        },

        getTempoFrazione(item, index = 0, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (index < numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][index]['time']);
                        else
                            return (item.rilevamenti[1][index]['time']);
                    }
                }
            }
            return undefined;
        },

        getUltimaFrazione(item, tailNum = 1, riduci = true) {
            if (this.isMultilap()) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        if (riduci)
                            return this.riduci(item.rilevamenti[1][numLaps - tailNum]['fraz']);
                        else
                            return (item.rilevamenti[1][numLaps - tailNum]['fraz']);
                    }
                }
            } else {
                if (item && item.rilevamenti) {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (this.isMultilap()) {
                            let numLaps = item.rilevamenti[index].length;
                            if (tailNum <= numLaps) {
                                if (riduci)
                                    return this.riduci(item.rilevamenti[index][numLaps - tailNum]['fraz']);
                                else
                                    return (item.rilevamenti[index][numLaps - tailNum]['fraz']);

                            }
                        }
                    }
                }
            }
            return undefined;
        },

        getMinTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz < curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        getMaxTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz > curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        isWarningCell(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return item.rilevamenti[1][numLaps - tailNum]['warning']
                }
            }
            return undefined;
        },

        setCurrentItem(item, colDef) {
            console.log(colDef)
            this.currentItem = item;

            if (colDef !== undefined && colDef.columnName == 'col_bands') {
                this.setCurrentBands(item);
                return;
            }

            this.currentRilevamenti = [];
            if (item.rilevamenti[1] !== undefined) {
                this.currentRilevamenti = item.rilevamenti[1];
            }
            this.dettaglio = true;
        },

        setCurrentBands(item) {
            this.currentItem = item;
            this.dettaglioBands = true;
        },

        setBands(item, numBands) {
            //alert("Premuto:" + numBands);
            item.col_bands = numBands;

            this.salvaBand(item, numBands);

        },

        orderBy(field) {
            console.log("Order by " + field)

            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },

        changedLabel(event) {
            console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedSex(event) {
            // console.log('Changed:' + event);
            this.sessoSelected = event;

            this.itemsF = this.filteredList();
        },

        changedDivisione(event) {
            this.divisioneSelected = event;
            this.itemsF = this.filteredList();
        },

        changedSearch(event) {
            //  console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },

        changedCategoria(event) {
            // console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedNazione(event) {
            this.nazioneSelected = event;
            this.itemsF = this.filteredList();
        },

        annullaFiltro() {
            this.sessoSelected = "TUTTI";
            this.categoriaSelected = "TUTTE";
            this.divisioneSelected = "TUTTE";
            this.nazioneSelected = "TUTTE";
            this.filtroDialog = false;
            this.itemsF = this.filteredList();
        },

        isChecked(pett) {
            console.log('is checked');
            return (
                this.listaPreferiti[pett] !== undefined &&
                this.listaPreferiti[pett] == pett
            );
        },

        refresh: function (self) {
            if (self.pause) return;
            self.currentIndex = 1;
            self.value = 0;
            self.numRilevamentiStep = 0;
            self.execute(self);
        },

        refreshBar: function (self) {
            if (self.pause) return;
            if (self.value == undefined) self.value = 0;
            // console.log("refreshBar :" + self.value)
            self.value += (100 / (self.refreshData / 1000));
            //console.log(self.value);
            if (self.value > 100) self.value = 0;

            const now = dayjs(new Date()).format('HH:mm:ss');
            this.raceTime = this.diffTime(now, this.configEvento.gunTime)
        },

        forceReload() {
            this.refresh(this);
        },

        getImgUrl(pet) {
            var images = require.context('../assets/images/', false, /\.png$/)
            return images('./' + pet + ".png")
        },

      

        removeUndefined(value) {
            if (value == undefined) return "";
            return value;
        },

        execute(self) {
            let startFrom = this.mappaFiles[self.currentIndex];
            if (startFrom == undefined) {
                this.mappaFiles[self.currentIndex] = 0;
                startFrom = 0;
            }

            const _url = this.getTagsURL() + "getFileTag?indexFrom=" + startFrom + "&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + this.currentIndex + "&indexTo=" + this.indexTo;
            console.log("EXECUTE:" + _url);

            self.getRemoteService(_url).then(
                (response) => {
                    if (response.length > 0) {
                        response = "tag;clock;antenna;progr\n" + response;
                        this.numRilevamentiStep += this.popolaPassaggi(response).length;
                    }
                    console.log("NUM RIL:" + this.numRilevamentiStep)

                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        this.loaded = true;

                        if (this.isOCR()) {
                            const _url = this.getDataURL() + "getFile?type=tags&idGara=" + this.raceID + "&fileName=BANDS.csv." + this.raceID + ".csv";
                            self.getRemoteService(_url).then(
                                (response) => {
                                    response = "tag;bands\n" + response;
                                    //console.log(response)
                                    if (response.length > 0) {
                                        const bands = this.csvJSON(response)
                                        bands.forEach(elem => {
                                            //console.log(elem);
                                            let p = this.chipMap[elem['tag']];
                                            if (p !== undefined) {
                                                p['col_bands'] = elem['bands'];
                                            }
                                        })
                                        this.showClassifica(self);
                                    } else {
                                        if (this.numRilevamentiStep > 0) this.showClassifica(self);
                                        else console.log("No refresh need")
                                    }
                                });

                        } else {
                            if (this.numRilevamentiStep > 0) this.showClassifica(self);
                            else console.log("No refresh need")

                        }


                    }
                }
            ).catch(
                (error) => {
                    console.log("Errore " + error);
                    self.mappaIntermedi[self.currentIndex] += 0;
                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        self.loaded = true;
                        if (this.numRilevamentiStep > 0) self.showClassifica(self);
                        else console.log("No refresh need")
                    }
                });

        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },

        compareRil(a, b, fieldName, index = 1) {
            if (a.rilevamenti[index].length === b.rilevamenti[index].length) {
                if (a.rilevamenti[index].length == 0) return 0;
                //const tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                //console.log(a);
                //console.log(b);
                //const tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                let tempoA = a[fieldName + index];
                let tempoB = b[fieldName + index];

                if (this.isMultilap()) {
                    tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                    tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                }

                //console.log("COMPARE:" +  a.rilevamenti[index].length + " - " + b.rilevamenti[index].length +" - " + tempoA + " " + tempoB);

                if (tempoA === undefined && tempoB == undefined) return 0;
                else if (tempoA === undefined) {
                    return -1
                } else if (tempoB === undefined) {
                    return 1
                }

                if (tempoA < tempoB) {
                    return -1;
                }
                if (tempoA > tempoB) {
                    return 1;
                }
                return 0;
            } else {
                return (b.rilevamenti[index].length - a.rilevamenti[index].length)
            }
        },


        compareRilUltra(a, b) {
            let tempoA = this.getFieldValue(b, { fieldType: 'distanza' })
            let tempoB = this.getFieldValue(a, { fieldType: 'distanza' })

            if (tempoA === undefined && tempoB == undefined) return 0;
            else if (tempoA === undefined) {
                return -1
            } else if (tempoB === undefined) {
                return 1
            }

            if (tempoA < tempoB) {
                return -1;
            }
            if (tempoA > tempoB) {
                return 1;
            }

            return this.compareRil(a, b, 'tempo', 1)

        },

        compare(a, b) {
            if (this.configEvento.criterioClass !== undefined && this.configEvento.criterioClass === 'bib') {
                return parseFloat(a.pett) - parseFloat(b.pett);
            } else {
                for (let index = (this.configEvento.numSplit); index > 0; index--) {
                    let res = this.compareRil(a, b, index);
                    if (res != 0) return res;
                }
            }
        },

        compareClassifica(a, b) {
            if (this.configEvento.criterioClass === undefined) {
                if (this.isUltra()) {
                    return this.compareRilUltra(a, b);
                } else if (this.isMultilap()) {
                    return this.compareRil(a, b, 'tempo', 1);
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        let res = this.compareRil(a, b, 'tempo', index);
                        if (res != 0) return res;
                    }
                }
            } else {
                let criterio = this.configEvento.criterioClass.split(",");
                let res = 0;
                for (let j = 0; j < criterio.length; j++) {
                    //this.orderByField = criterio[j];
                    if (criterio[j] === 'tempo') {
                        console.log("CLASSIFICA CON CRITERIO: " + criterio[j] + " >> " + res)
                        for (let index = (this.configEvento.numSplit); index > 0; index--) {
                            res = this.compareRil(a, b, 'tempo', index);
                            if (res != 0) return res;
                        }
                    } else {
                        res = this.compareField(a, b, criterio[j])
                        console.log("Stesso valore: " + criterio[j] + " >> " + res)
                        if (res != 0) return res;
                    }
                }
            }


        },

        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        clockCompare(a, b) {
            return this.compareField(a, b, 'lastClock')
        },

        showClassifica(self) {

            let mappaPosClassifica = {};

            let clockPrimo = null;
            let clockUltimo = null;

            let posAss = 1;
            let posM = 1;
            let posF = 1;

            this.elencoIscritti.sort(this.compareClassifica);
            this.elencoIscritti.forEach(elem => {
                let keyPos = "DIV_" + elem.divisione + "_" + elem.sesso;
                let counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posDiv = mappaPosClassifica[keyPos];
                elem.posAss = posAss++;

                if (elem.sesso === 'F') {
                    elem.posMF = posF++;
                } else {
                    elem.posMF = posM++;
                }

                keyPos += "_CAT_" + elem.categoria;
                counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posCat = mappaPosClassifica[keyPos];

                if (this.isMultilap()) {
                    let indexRil = 0;
                    elem.rilevamenti[1].forEach(rilev => {
                        const warn = this.isWarning(elem.rilevamenti[1], rilev, indexRil);
                        rilev.warning = warn;
                        if (warn) elem.warning = true;
                        indexRil++;
                    })
                }

                if (this.showMedia) {
                    elem.media = this.calcolaMedia(elem.tempo, elem.distanzaDivisione, this.configEvento.unitaMedia);
                }

                if (this.showGap) {
                    if (this.isMultilap()) {


                        if (clockPrimo == null) {
                            console.log("Primo")
                            //elem.distacco1 = elem.tempo;
                            elem.distacco1 = ""
                            elem.distacco2 = "";
                            clockPrimo = elem.lastTime;


                        } else {
                            if (elem.lastTime > clockPrimo) {
                                elem.distacco1 = "+" + this.riduci(this.diffTime(elem.lastTime, clockPrimo));
                            } else {
                                elem.distacco1 = "-";
                            }
                            if (elem.lastTime >= clockUltimo) {
                                elem.distacco2 = "+" + this.riduci(this.diffTime(elem.lastTime, clockUltimo));
                            } else {
                                elem.distacco2 = "-";
                            }
                        }
                        clockUltimo = elem.lastTime;



                    } else {
                        if (clockPrimo == null) {
                            console.log("Primo")
                            //elem.distacco1 = elem.tempo;
                            elem.distacco1 = ""
                            elem.distacco2 = "";
                            clockPrimo = elem.tempo;
                            if (this.isMultilap()) {
                                clockPrimo = elem.lastTime;
                            }
                        } else {
                            if (elem.tempo > clockPrimo) {
                                elem.distacco1 = "+" + this.riduci(this.diffTime(elem.tempo, clockPrimo));
                            } else {
                                elem.distacco1 = "-";
                            }
                            if (elem.tempo >= clockUltimo) {
                                elem.distacco2 = "+" + this.riduci(this.diffTime(elem.tempo, clockUltimo));
                            } else {
                                elem.distacco2 = "-";
                            }
                        }
                        clockUltimo = elem.tempo;

                    }




                }

            });

            self.items = this.elencoIscritti;
            self.itemsF = this.filteredList();

            self.itemsF2 = this.filteredList2();

        },

        isRilevamentoValido(listaRilevamentiAtleta, clock, idPassaggio, laps, guntime, finishTime, winnerTime) {

            const t1 = dayjs(this.normalizzaTS(this.getTime(clock)));
            const tGUN = dayjs(this.normalizzaTS(this.getTime(guntime)));
            if (t1.valueOf() < tGUN.valueOf()) return false;

            if (finishTime !== undefined && finishTime !== '') {
                const tFinish = dayjs(this.normalizzaTS(this.getTime(finishTime)));
                if (t1.valueOf() > tFinish.valueOf()) return false;
            }

            let valTime = 0;
            if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
            }
            if (listaRilevamentiAtleta.length == 0) {
                if (t1.valueOf() - tGUN.valueOf() < valTime) {
                    return false;
                }
                return true;
            }

            if (this.configEvento['type' + idPassaggio] !== undefined && this.configEvento['type' + idPassaggio] == 'last') {
                return true;
            }


            if (listaRilevamentiAtleta.length < laps) {

                let valTime = 0;
                if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                    valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                }
                let ultimoPassaggio = this.getTime(listaRilevamentiAtleta[listaRilevamentiAtleta.length - 1].clock);
                //if (ultimoPassaggio.indexOf(".") == -1) ultimoPassaggio += ".000";

                const t0 = dayjs(this.normalizzaTS(ultimoPassaggio)).utc();
                const t1 = dayjs(this.normalizzaTS(this.getTime(clock))).utc();

                if (winnerTime !== undefined) {
                    const tWinner = dayjs(this.normalizzaTS(winnerTime)).utc();
                    if (t0.valueOf() > tWinner.valueOf()) return false;
                }

                //console.log(tempoOrig);
                const diff = t1.valueOf() - t0.valueOf();
                if (diff >= valTime) {
                    return true;
                } else {
                    //if (this.configEvento.debug) {
                    console.log("Valtime > " + valTime);
                    console.log(ultimoPassaggio + " > " + t0.valueOf());
                    console.log(this.getTime(clock) + " > " + t1.valueOf());
                    console.log("DIFF:" + diff);
                    // }
                }
            } else {
                console.log("Scarto numLap superiori a quelli ammessi nel passaggio  ");
            }
            return false;
        },

        popolaPassaggi(data) {
            let index = this.currentIndex;
            console.log("popolaPassaggi>" + index);

            let lista = this.csvJSON(data);
            console.log("aggiungo >" + lista.length + " letture");
            if (this.configEvento.debug) console.log("aggiungo >" + JSON.stringify(lista));
            this.mappaFiles[index] += lista.length;

            let result = [];

            lista.forEach(elem => {
                if (elem.clock === undefined) {
                    //console.log("Time " + elem.clock + " is before cut: " + cutFrom);
                } else {

                    let laps = 1;
                    if (this.configEvento['numLap' + index] !== undefined) {
                        laps = parseInt(this.configEvento['numLap' + index]);
                    }

                    let p = this.chipMap[elem['tag']];
                    if (p !== undefined) {
                        let pettorale = p['pett'];

                        if (this.mappaDivisioni[p.divisione] !== undefined && this.mappaDivisioni[p.divisione]['numGiri'] > 0) {
                            laps = this.mappaDivisioni[p.divisione]['numGiri']
                        }

                        let _finishTime = p.finishtime;
                        //console.log("FINISH TIME>" + _finishTime + "<")
                        if ((_finishTime === '' || _finishTime == undefined) && this.configEvento['finishTime' + p['divisione']] !== undefined) {
                            _finishTime = this.configEvento['finishTime' + p['divisione']];
                        }

                        let _winnerTime = this.configEvento.winnerTime;
                        if (this.configEvento['winnerTime' + p['divisione']] !== undefined) {
                            _winnerTime = this.configEvento['winnerTime' + p['divisione']];
                        }

                        if (this.isRilevamentoValido(p.rilevamenti[index], elem.clock, index, laps, p.guntime, _finishTime, _winnerTime)) {
                            //console.log("DEBUG:>>");


                            if (index == 1 && this.isRealTime()) {
                                p.guntime = elem.clock
                            }

                            const _tempo = this.getTempo(p.guntime, elem.clock);
                            const _clock = elem.clock; //this.getTime(elem.clock);
                            let _fraz = (this.diffTime(elem.clock, p.guntime, this.configEvento.frazFormat));


                            if (this.configEvento['type' + index] !== undefined && this.configEvento['type' + index] === 'last') {
                                console.log("LAST:" + this.configEvento['type' + index])
                                let obj = {
                                    pett: p.pett,
                                    time: _tempo,
                                    clock: _clock,
                                    fraz: _fraz,
                                    lap: 1
                                }

                                if (p.rilevamenti[index].length == 0)
                                    p.rilevamenti[index].push(obj);
                                else
                                    p.rilevamenti[index][0] = obj;

                            } else {

                                if (this.isMultilap()) {
                                    if (p.rilevamenti[index].length > 0) {
                                        _fraz = (this.diffTime(_tempo, p.rilevamenti[index][p.rilevamenti[index].length - 1].time, this.configEvento.frazFormat));
                                    }
                                } else {
                                    if (index > 1 && p.rilevamenti[index - 1].length > 0) {
                                        _fraz = (this.diffTime(_tempo, p.rilevamenti[index - 1][p.rilevamenti[index - 1].length - 1].time, this.configEvento.frazFormat));
                                    }
                                }

                                p.rilevamenti[index].push({
                                    pett: p.pett,
                                    time: _tempo,
                                    clock: _clock,
                                    fraz: _fraz,
                                    lap: p.rilevamenti[index].length + 1
                                });
                            }

                            if (p.rilevamenti[index].length == laps) {

                                //if (laps > 1 ) console.log("PASSAGGI CORRETTI:" + p.cognome + " " + p.pett)
                                p.clock = this.getTime(elem.clock);
                                p.tempo = this.getTempo(p.guntime, elem.clock)

                                p['tempo' + index] = this.getTempo(p.guntime, elem.clock);
                                p['clock' + index] = _clock;
                                p['fraz' + index] = _fraz; // this.getTime(_fraz);
                            }

                            p.lastClock = _clock;
                            p.lastTime = _tempo;
                            p.laps = p.rilevamenti[index].length;

                            result.push(p);
                        } else {
                            console.log("passaggio non valido:" + elem.tag + " " + p.cognome + " " + elem.clock + " >>" + JSON.stringify(p.rilevamenti[index]));
                        }
                    } else {
                        if (this.configEvento.debug) console.log("Tag " + elem.tag + " sconosciuto");
                    }

                }

            })

            this.mappaIntermedi[index] += result.length;
            return result;

        },

        isWarning(listaRil, rilevamento, indexRil) {
            if (listaRil.length > 1) {
                var utc = require('dayjs/plugin/utc')
                dayjs.extend(utc)

                let ttMin = undefined;
                if (indexRil == 0) return false;

                let indexFrom = indexRil;
                let indexTo = indexFrom + this.warningLaps;

                if (indexRil < this.warningLaps) {
                    indexFrom = 0;
                    indexTo = indexRil;
                } else {
                    indexFrom = indexRil - this.warningLaps;
                    indexTo = indexRil;
                }
                //alert(minVal)

                let last5 = listaRil.slice(indexFrom, indexTo);
                //console.log("da: " + (indexFrom) + " a: " + (indexTo) );

                let min = last5.reduce(function (prev, curr) {
                    //console.log(rilevamento.pett + " >> " + prev.fraz + " - " + curr.fraz);
                    return prev.fraz < curr.fraz ? prev : curr;
                });
                ttMin = min.fraz
                //console.log("WINNER >> " + ttMin)

                const tt0 = this.normalizzaTS(rilevamento.fraz);
                const tt1 = this.normalizzaTS(ttMin);

                const t0 = dayjs(this.getIsoDate(tt0)).utc() + 3600000;
                const tMin = dayjs(this.getIsoDate(tt1)).utc() + 3600000;

                if ((t0.valueOf()) > ((tMin.valueOf()) * this.warningDelta)) {
                    return true;
                }

            }
            return false;
        },

        getTempo(guntime, tempoRil) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(tempoRil);

            //console.log("getTempo: " + tt0+" "+ tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format("HH:mm:ss.SSS");

            //console.log(">getTempo: " +result);

            if (result === 'Invalid Date') return tempoRil;

            return result;
        },

        gotoHome() {
            this.$router.push('/');
        },

        gotoAdmin() {
            this.$router.push('/admin');
        },

        getStyle(index, n) {
            if (n != undefined) return n;
            if (index % 2 == 0) return "grey lighten-4"
            return "white"
        },

        getClasseFiltro() {
            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                return "red--text"
            } else if (this.divisioneSelected !== 'TUTTE' && this.divisioneSelected !== undefined && this.divisioneSelected !== '') {
                return "red--text"
            } else if (this.nazioneSelected !== 'TUTTE' && this.nazioneSelected !== undefined && this.nazioneSelected !== '') {
                return "red--text"
            } else if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                return "red--text"
            }
            return ''
        },

        toggleWarning() {
            this.onlyWarning = !this.onlyWarning;
            this.itemsF = this.filteredList();
        },

        toggleCompatta() {
            this.compatta = !this.compatta;
        },

        toggleSearch() {
            this.filterToggle = !this.filterToggle;
            window.scrollTo(0, 0);
        },

        togglePreferiti() {
            this.filterPreferiti = !this.filterPreferiti;
            this.showClassifica(this.raceData);
        },
        toggleItem(pett) {
            if (this.listaPreferiti[pett] == undefined) {
                this.listaPreferiti[pett] = pett;
            } else {
                this.listaPreferiti[pett] = undefined;
            }
            console.log(pett + '-->' + this.listaPreferiti[pett]);
            helper.ls.set(
                'PREFERITI_' + this.$route.params.raceID,
                this.listaPreferiti
            );
            //this.togglePreferiti();
            //this.togglePreferiti();
            //this.showClassifica(this.raceData);
        },

        filteredList() {
            var listaSearch = this.items;
           

            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }

            if (this.configEvento.righeFisse || this.configEvento.righeCoda) {
                let myArray = listaSearch.filter(elem => {
                    return elem.lastClock !== undefined;
                });
                const rCoda = parseInt(this.configEvento.righeCoda);
                const rFisse = parseInt(this.configEvento.righeFisse);

                let _righeFisse = [];
                let _righeVariabili = [];

                if (myArray.length > rCoda) {
                    if (this.configEvento.righeFisse) {
                        _righeFisse = myArray.slice(0, rFisse);
                    }
                }

                return _righeFisse;

              /*  if (this.configEvento.righeCoda) {
                    const l = myArray.length;
                    myArray = myArray.slice(_righeFisse.length);
                    //console.log(myArray)
                    _righeVariabili = myArray.sort(this.clockCompare);
                    _righeVariabili = _righeVariabili.slice(0, rCoda ).reverse();
                }
                return _righeFisse.concat(_righeVariabili);*/
            }

            return listaSearch;
        },


        filteredList2() {
            var listaSearch = this.items;
           

            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }

            if (this.configEvento.righeFisse || this.configEvento.righeCoda) {
                let myArray = listaSearch.filter(elem => {
                    return elem.lastClock !== undefined;
                });
                const rCoda = parseInt(this.configEvento.righeCoda);

                let _righeFisse = [];
                let _righeVariabili = [];

                if (this.configEvento.righeCoda) {
                    const l = myArray.length;
                    myArray = myArray.slice(_righeFisse.length);
                    //console.log(myArray)
                    _righeVariabili = myArray.sort(this.clockCompare);
                    _righeVariabili = _righeVariabili.slice(0, rCoda ).reverse();
                }
                return _righeFisse.concat(_righeVariabili);
            }

            return listaSearch;
        },

      
        getFields() {
            // if (!this.isMultilap()) {
            //console.log("getFields")
            if (this.fields && this.fields.length > 0) {
                let lista = [];
                this.fields.forEach(elem => {
                    let label = this.getFieldlabel(elem);;
                    elem = this.getFieldName(elem)

                    let _elem = elem.replace("FRAC_", "")
                    _elem = _elem.replace("CLOCK_", "")
                    _elem = _elem.replace("TIME_", "")
                    let fieldType = "tempo"
                    if (elem.startsWith("FRAC_")) {
                        fieldType = "fraz"
                    } else if (elem.startsWith("CLOCK_")) {
                        fieldType = "clock"
                    } else if (elem.startsWith("COL_") || elem.startsWith("GUNTIME")) {
                        fieldType = "field"
                    } else if (elem.startsWith("metri")) {
                        fieldType = "distanza"
                        const _obj = {
                            splitNum: 0,
                            fieldType: fieldType,
                            columnName: elem,
                            label: label
                        };
                        // console.log(_obj)
                        lista.push(_obj);
                    }

                    if (fieldType == "field") {
                        const _obj = {
                            splitNum: -1,
                            fieldType: fieldType,
                            columnName: _elem.toLowerCase(),
                            label: label
                        };
                        // console.log(_obj)
                        lista.push(_obj);
                    } else {
                        for (let index = (this.configEvento.numSplit); index > 0; index--) {
                            if (this.configEvento['titolo' + index] === _elem) {
                                const _obj = {
                                    splitNum: index,
                                    fieldType: fieldType,
                                    columnName: elem,
                                    label: label
                                };
                                // console.log(_obj)
                                lista.push(_obj);
                            }
                        }
                    }
                })
                return lista;
            }
            return this.listaIntermedi;
            //  } else {
            //      return this.listaIntermedi;
            //  }
        }

    },
};
</script>
    
<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
    padding: 0 10px;
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    _border-radius: 0px 0px 7px 7px;
    _font-weight: bold;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
    _border-radius: 0px 5px 5px 0px;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 0px 0px 7px 7px;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 5px 0px 0px 5px;
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
    _border-radius: 0px 0px 7px 7px;
}

.passaggio {
    background-color: lightgrey;
    text-align: center;
    color: green;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 5px 5px 5px 5px;
    _font-weight: bold;
}

.laps {
    text-align: center;
    color: white;
    font-style: italic;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
}

.cardUp {
    background-color: #212121;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardStatsHeader {
    background-color: #212121;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}

.theme--light.application {
    background: transparent !important;
    color: transparent !important;
}


</style>
    